<template>
<div id="refund_eligible" class="fleet-form-main">
    <div :class="`loader${loaderClass}`" v-show="loading">
    </div>
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="cantAccessPage === true">

            <div class="page-name">
                <span class="page-title" id="invoiceHeader">Eligible Customer for Refund</span>
                <clear-cache-data :pageKey="[pageKey1,pageKey2,pageKey3,pageKey4]" ></clear-cache-data>
            </div>

            <div class="container-fluid">
              <!--div class="admin-page-content contract-crud"-->
                <section class="internal-container border-top-table-fl">

                    <div class="admin-page-content refund-eligible-list">
                        <data-table-filter-config :moduleName="'listRefundEligibleCustomerTable'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="bg-white data-table">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'listRefundEligibleCustomerTable'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="listRefundEligibleCustomerTable"
                                    mode="remote"
                                    title="Eligible Customer for Refund"
                                    @on-page-change="onPageChange"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    @on-select-all="onSelectAll"
                                    :totalRows="totalRecords"
                                    :columns="columns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        setCurrentPage:listCurrentPage,
                                        perPage: perPage,
                                    }"
                                    :select-options="{
                                    enabled: canDeleteCustomer,
                                      selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                      selectionInfoClass: 'custom-class',
                                      selectionText: 'rows selected',
                                      clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                      enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows" >
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'">
                                                <div slot="selected-row-actions">


                                                    <button title="Print Refund Statement" v-on:click.prevent="printRefundStatment(props.row.id)" class="btn btn-secondary" style="padding-right: 3px;">
                                                    <i class="fp-print"></i></button>

                                                    <!--button title="Customer Refund Detail" v-on:click.prevent="refundDetailView(props.row.code)" class="btn btn-secondary" style="padding-right: 3px;">
                                                    <i class="fp-view"></i></button-->



                                                    <!--a href="javascript:void(0)" title="Agreement Download" v-on:click="generateAgreementPdf(props.row.id)">
                                                        <i class="fp-export"></i>
                                                    </a-->

                                                    <!--button title="Send Refund Statement" v-on:click.prevent="sendEmail(props.row.id)" class="btn btn-primary" style="padding-right: 3px;">
                                                    <i class="fp-send-message" style="font-size:20px;"></i></button>

                                                    <button title="Revert Refund Status" v-on:click.prevent="refundDelete(props.row.id)" class="btn btn-danger" style="padding-right: 3px;">
                                                    <i class="fp-delete"></i></button-->
                                                </div>
                                            </div>
                                            <div v-if="props.column.field == 'code'">
                                                <router-link v-if="canViewCustomer" title="View Customer" class="color-blue" v-bind:key="'action_view' + key" v-bind:to="{name: 'CustomerView',params:{id:props.row.id},query:{fromUrl:fromUrl}}">{{props.row.code}}</router-link>
                                            </div>
                                            <div v-else-if="props.column.field == 'on_account'
                                            || props.column.field == 'open_invoice'|| props.column.field == 'refund_amount' || props.column.field == 'security'">
                                                <!--{{props.row.code}} -->
                                                ${{amountFormat(props.formattedRow[props.column.field])}}
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>
                                    <div slot="selected-row-actions">
                                        <button v-if="canProcessRefund == true" id="print" v-on:click.prevent="initiateRefundMultiple()" class="btn btn-primary">Initiate Refund</button>
                                        <button id="print" v-on:click.prevent="printRefundStatmentMultiple()" class="btn btn-primary">Download</button>
                                    </div>
                                </vue-good-table>

                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                    <!--div class="btn-groups" v-if="enableEmail">
                        <button type="submit" id="customerStatementSendBtn" class="btn btn-primary" v-on:click.prevent="customerStatementSend">
                            <i class="fp-reload"> </i>  Send
                        </button>
                        <button type="submit" id="cancelCardRateHeaderBtn" class="btn btn-tertiary" v-on:click.prevent="cancelStatement()">
                            <i class="fp-close"> </i>  Cancel
                        </button>
                    </div-->
                </section>
              <!--/div-->
            </div>

        </template>
        <template v-else-if="cantAccessPage === false">
            <div class="container-fluid">
                <div class="bg-white text-center">
                    <h1>
                        Oops!</h1>
                    <h2>
                        403 </h2>
                    <div class="error-details">
                        Sorry!, You don't have permission to access this page.
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <loading-content></loading-content>
        </template>
        <app-footer></app-footer>
    </div>

</div>
</template>

<script>

import Vue from "vue";

import { commonMixins } from "../../../mixins/commonMixins";
import {contractMixins} from '../../../mixins/contractMixins';

import { dataTableMixins } from '../../../mixins/dataTableMixins';
export default {
  name: "RefundEligibleList",
    metaInfo() {
        return {
            title: "Eligible Customer for Refund | " +process.env.COPYRIGHT_NAME
        }
    },
    mixins:[commonMixins,contractMixins,dataTableMixins],
    data: () => ({
      pageKey1: '_refund_eligible_list_',
      pageKey2: '_refund_customer_onaccount_',
      pageKey3: '_refund_customer_sec_depo_',
      pageKey4: '_refund_customer_open_invoice_',
      permissions: [],
      cantAccessPage: "",
      canDeleteCustomer:false,
      canUpdateCustomer:false,
      canViewCustomer:false,
      canAddCustomerContact:false,
      loading:false,
      columns: [
          {
              label: 'Customer Code',
              field: 'code',
              filterable: true,
              fpFieldType:"text",
              width:'140px',
              hidden:false,
              filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "Customer Code", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  filterFn: this.onColumnFilter,
                  trigger: "enter" //only trigger on enter not on keyup
              }
          },
          {
              label: 'Customer Name',
              field: 'name',
              filterable: true,
              fpFieldType:"text",
              hidden:false,
              filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "Customer Name", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
              }
          },
          {
              label: 'Agreements',
              field: 'agreements',
              fpFieldType:"integer",
              filterable: false,
              hidden:false,
              type:'number',
              filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "Agreements", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
              },
              sortable:false
          },
          {
              label: 'Contracts',
              field: 'contracts',
              fpFieldType:"integer",
              filterable: false,
              hidden:false,
              type:'number',
              filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "Contracts", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
              },
              sortable:false
          },
          {
              label: 'On Account',
              field: 'on_account',
              fpFieldType:"integer",
              filterable: false,
              hidden:false,
              type:'number',
              filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "On Account", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
              },
              sortable:false
          },
        //   {
        //       label: 'Security Deposit',
        //       field: 'security',
        //       fpFieldType:"integer",
        //       filterable: false,
        //       hidden:false,
        //       type:'number',
        //       filterOptions: {
        //           enabled: false, // enable filter for this column
        //           placeholder: "Security Deposit", // placeholder for filter input
        //           filterValue: '', // initial populated value for this filter
        //           trigger: "enter" //only trigger on enter not on keyup
        //       },
        //       sortable:false
        //   },
          {
              label: 'Credit Invoice',
              field: 'credit_invoice',
              fpFieldType:"integer",
              filterable: false,
              hidden:false,
              type:'number',
              filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "Security Deposit", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
              },
              sortable:false
          },
          {
              label: 'Open Invoice',
              field: 'open_invoice',
              fpFieldType:"integer",
              filterable: false,
              hidden:false,
              type:'number',
              filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "Open Invoice", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
              },
              sortable:false
          },
          {
              label: 'Refund Amount',
              field: 'refund_amount',
              fpFieldType:"integer",
              filterable: false,
              hidden:false,
              type:'number',
              filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "Refund Amount", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
              },
              sortable:false
          },
          {
              label: 'Actions',
              field: 'action',
              hidden:false,
              sortable: false,
          },
      ],
      rows: [],
      totalRecords: 0,
      fromUrl:"",
      canProcessRefund:""
    }),
    watch:{
      permissions: function (permissions) {
          var self = this;
          if (permissions.length > 0) {
              for (var i = 0; i < permissions.length; i++) {
                  if (permissions[i].name == 'refund_eligible_customers') {
                      self.cantAccessPage = true;
                  }
                   else if (permissions[i].name == 'view_customer') {
                      self.canViewCustomer = true;
                  } else if (permissions[i].name == 'add_customer') {
                      self.canUpdateCustomer = true;
                      self.canAddCustomer = true;
                  } else if (permissions[i].name == 'add_customer_contact') {
                      self.canAddCustomerContact = true;
                  } else if (permissions[i].name == 'delete_customer') {
                      self.canDeleteCustomer = true;
                  }  else if (permissions[i].name == 'refund_process') {
                      self.canProcessRefund = true;
                  }
              }
          }
      },
    },
    mounted: function() {
        var self = this;
        self.fromUrl = btoa(window.location.pathname);
        self.getPermissions();
        //self.loadList(); function called double time
    },
    methods: {
      refundDetailView: function(code) {
        var self = this;
        console.log(code);
      },
      cancelAll: function (cancelAll) {
        this.$refs.listRefundEligibleCustomerTable.unselectAllInternal();
      },
      loadList() {
          var self = this;
          self.loading = true;

          var date = new Date();
          var offset = date.getTimezoneOffset();

          var selectedRows = [];

          if ( self.firstLoad == 1 ) {
              //because on first load list not initialize
              var data = this.$refs['listRefundEligibleCustomerTable'].selectedRows;
              for ( var i = 0; i < data.length; i++ ) {
                  selectedRows.push(this.$refs['listRefundEligibleCustomerTable'].selectedRows[i].id)
              }
          }

          self.firstLoad = 1;
          $.ajax({
              url: process.env.ROOT_API + "/refund/eligible/list",
              type: "POST",
              data: {
                  page: self.serverParams.page,
                  perPage: self.serverParams.perPage,
                  filters: self.serverParams.columnFilters,
                  sort: self.serverParams.sort,
                  offset: offset,
              },
              headers: this.ajxHeaders,
              dataType: "json",
              success: function (data) {
                  self.loading = false;
                  console.log(data);
                  if (data.status == "success") {

                      self.rows = data.content.row;
                      self.totalRecords = data.content.totalRecords;
                      self.filteredFlag = false;
                  }
              },
              error: function (jqXHR, exception) {
                  self.loading = false;
                  if ( self.action == "delete" ) {
                      self.generateStatusCodeMessage(jqXHR,true,'customer-delete-error')
                  }else if (self.action =='export')
                  {
                      self.generateStatusCodeMessage(jqXHR,true,'customer-export-error')
                  }else{
                      self.generateStatusCodeMessage(jqXHR,false,'customer-list-error')
                  }

              }
          });
      },
      printRefundStatment(id) {
        var self = this;
        self.selectedCustomerId = [];
        self.selectedCustomerId.push(id);
        // self.selectedCustomerId = [id];
        console.log(self.selectedCustomerId);
        this.printDownload();
      },
      printRefundStatmentMultiple() {

        var data = this.$refs['listRefundEligibleCustomerTable'].selectedRows;
        var self = this;
        var use = [];
        for (var i = 0; i < data.length; i++) {
            use.push(this.$refs['listRefundEligibleCustomerTable'].selectedRows[i].id)
        }
        self.selectedCustomerId = [];
        self.selectedCustomerId = use;
        console.log(self.selectedCustomerId);
        self.printDownload();

      },
      printDownload: function() {

        var self = this;
        self.loading = true;

        $.ajax({
            url: process.env.ROOT_API + "/refund/statement/download",
            type: "POST",
            data: {
              customer: self.selectedCustomerId,
              from:'eligible'
              },
            headers: this.ajxHeaders,
            success: function (data) {
                if (data.status == 'success'){
                    var link = document.createElement('a');
                    document.body.appendChild(link);
                    link.href = data.content;
                    link.download = '';
                    link.target = "_blank";
                    link.click();
                }
                self.loadList();
            },
            error: function (jqXHR, exception) {
                self.modalLoading = false;
                self.reqeustSent = 0;
                self.generateStatusCodeMessage(jqXHR,true,'email-report-invoice-template-download');
            }
        });

      },
      initiateRefundMultiple() {

        var self = this;

        self.loading = true;

        var data = this.$refs['listRefundEligibleCustomerTable'].selectedRows;
        var self = this;
        var use = [];
        for (var i = 0; i < data.length; i++) {
            use.push(this.$refs['listRefundEligibleCustomerTable'].selectedRows[i].id)
        }


        $.ajax({
            url: process.env.ROOT_API + "/refund/status",
            type: "POST",
            crossDomain: true,
            headers: this.ajxHeaders,
            dataType: "json",
            data:{
                ids: use,
                status: 1,
            },
            success: function(data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {
                  self.cancelAll(true);
                  self.loadList();

                }

            },
            error: function(jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'invoice-list');
            }
        });
      },

    },

}
</script>



// WEBPACK FOOTER //
// src/components/accounting/refund/RefundEligibletList.vue